import {tryAxios} from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/Lookup`
//#region Lookup相关
export const GetCruiseTeams = `${apiUrl}/GetCruiseTeams`
export const GetParentList = `${apiUrl}/GetParentList`
export const GetChildList = `${apiUrl}/GetChildList`
export const GetList = `${apiUrl}`
export const Get = (id: number) => `${apiUrl}/${id}`
export const Delete = (id: number) => `${apiUrl}/${id}`
export const Put = (id: number) => `${apiUrl}/${id}`
export const Post = `${apiUrl}`
//#endregion

export const getCruiseTeams = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetCruiseTeams,
        params: param
    })
}
export const getParentList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetParentList,
        params: param
    })
}
export const getChildList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetChildList,
        params: param
    })
}

export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}

export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}

export const getData = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}

export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}

export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}

export interface LookupData {
    [key: string]: any
    Id: number
    LookupType: string
    ItemCode: string
    ItemValue: string
    SubSequence: number
    ResveredFlag1: boolean
    ResveredFlag2: boolean
    ResveredDesc: string
    Comments: string

    ParentId: number
    ParentType: string
    ParentName: string
    GroupName: string
    LookupTypeName: string
}
